import React from 'react';
import { HbrButton, HbrIcon, HbrTag } from '@harbor/elements-react-standalone';
import { lightning } from '@harbor/elements/icons';

const styles = {
  menuItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
    padding: 14,
  } as React.CSSProperties,

  prefix: {
    flex: '0 0 20px',
    width: 20,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--hbr-color-neutral-icon, #7E868F)',
    marginTop: 2,
  } as React.CSSProperties,

  content: {
    flex: '1 1 auto',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  } as React.CSSProperties,

  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    minWidth: 0,
  } as React.CSSProperties,

  rowLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
    flexWrap: 'wrap',
  } as React.CSSProperties,

  heading: {
    fontSize: 14,
    color: '#596069',
  } as React.CSSProperties,

  labelBold: {
    fontWeight: 600,
    fontSize: 'var(--hbr-font-size-sm, 14px)',
    color: 'black',
    lineHeight: '20px',
  } as React.CSSProperties,

  label: {
    fontWeight: 400,
    fontSize: 'var(--hbr-font-size-sm, 14px)',
    color: '#596069',
    lineHeight: '20px',
  } as React.CSSProperties,

  suffix: {
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
  } as React.CSSProperties,
};

const providerLabel = (authProvider: 'salesforce' | 'cisco_sso' | null) => {
  if (authProvider === 'salesforce') return 'Salesforce';
  if (authProvider === 'cisco_sso') return 'Cisco SSO';
  return 'Unknown';
};

const UserProfileAuthSection: React.FC<{
  authProvider: 'salesforce' | 'cisco_sso' | null;
  hasSalesforceAccess: boolean;
  onConnectSalesforce: () => void;
}> = ({ authProvider, hasSalesforceAccess, onConnectSalesforce }) => {
  const isCiscoOnly = authProvider === 'cisco_sso' && !hasSalesforceAccess;
  const isSalesforceConnected = authProvider === 'salesforce' && hasSalesforceAccess;

  if (isCiscoOnly) {
    return (
      <div style={styles.menuItem}>
        <div style={styles.prefix}>
          <HbrIcon asset={lightning} style={{ fontSize: 20 }} />
        </div>

        <div style={styles.content}>
          <div style={styles.row}>
            <div style={styles.rowLeft}>
              <div style={styles.heading}>Authentication source</div>
              <div style={styles.labelBold}>{providerLabel(authProvider)}</div>
            </div>

            <div style={styles.suffix}>
              <HbrTag sentiment="success">Connected</HbrTag>
            </div>
          </div>

          <div style={styles.row}>
            <div style={styles.rowLeft}>
              <div style={styles.label}>Salesforce</div>
              <div style={styles.label}>Not connected</div>
            </div>

            <div style={styles.suffix}>
              <HbrButton variant="outline" onClick={onConnectSalesforce}>
                Connect Salesforce
              </HbrButton>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isSalesforceConnected) {
    return (
      <div style={styles.menuItem}>
        <div style={styles.prefix}>
          <HbrIcon asset={lightning} style={{ fontSize: 20 }} />
        </div>

        <div style={styles.content}>
          <div style={styles.row}>
            <div style={styles.rowLeft}>
              <div style={styles.heading}>Authentication source</div>
              <div style={styles.labelBold}>Salesforce</div>
            </div>

            <div style={styles.suffix}>
              <HbrTag sentiment="success">Connected</HbrTag>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.menuItem}>
      <div style={styles.prefix}>
        <HbrIcon asset={lightning} style={{ fontSize: 20 }} />
      </div>

      <div style={styles.content}>
        <div style={styles.row}>
          <div style={styles.rowLeft}>
            <div style={styles.heading}>Authentication source</div>
            <div style={styles.labelBold}>{providerLabel(authProvider)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfileAuthSection;